import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import AppShell from "./components/AppShell";
import Login from "./pages/Login";
import PinGate, { getVisitor } from "./pages/PinGate";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import KYCQueue from "./pages/KYCQueue";
import Transactions from "./pages/Transactions";
import Alerts from "./pages/Alerts";
import AlertDetail from "./pages/AlertDetail";
import Screening from "./pages/Screening";
import Watchlists from "./pages/Watchlists";
import AdverseMedia from "./pages/AdverseMedia";
import Cases from "./pages/Cases";
import CaseDetail from "./pages/CaseDetail";
import ReportingSTR from "./pages/ReportingSTR";
import STRDetail from "./pages/STRDetail";
import ReportingCTR from "./pages/ReportingCTR";
import ReportingFTR from "./pages/ReportingFTR";
import BoardReports from "./pages/BoardReports";
import Models from "./pages/Models";
import ModelDetail from "./pages/ModelDetail";
import AtomExplainer from "./pages/AtomExplainer";
import AuditLog from "./pages/AuditLog";
import AccessControl from "./pages/AccessControl";
import ExaminationReadiness from "./pages/ExaminationReadiness";
import ComplianceCulture from "./pages/ComplianceCulture";
import Integrations from "./pages/Integrations";
import Settings from "./pages/Settings";
import MyWork from "./pages/MyWork";
import BeneficialOwnership from "./pages/BeneficialOwnership";
import BehaviouralAnalytics from "./pages/BehaviouralAnalytics";
import TransactionScreening from "./pages/TransactionScreening";
import CustomerBaseSweep from "./pages/CustomerBaseSweep";
import { Toaster } from "sonner";

function GateGuard({ children }) {
  const v = getVisitor();
  if (!v || !v.token) return <Navigate to="/gate" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/gate" element={<PinGate />} />
          <Route path="/login" element={<GateGuard><Login /></GateGuard>} />
          <Route element={<GateGuard><AppShell /></GateGuard>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/my-work" element={<MyWork />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/customers/:cid" element={<CustomerDetail />} />
            <Route path="/kyc" element={<KYCQueue />} />
            <Route path="/beneficial-ownership" element={<BeneficialOwnership />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/transaction-screening" element={<TransactionScreening />} />
            <Route path="/customer-sweep" element={<CustomerBaseSweep />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/alerts/:aid" element={<AlertDetail />} />
            <Route path="/screening" element={<Screening />} />
            <Route path="/screening/watchlists" element={<Watchlists />} />
            <Route path="/screening/adverse-media" element={<AdverseMedia />} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/cases/:cid" element={<CaseDetail />} />
            <Route path="/reporting/str" element={<ReportingSTR />} />
            <Route path="/reporting/str/:sid" element={<STRDetail />} />
            <Route path="/reporting/ctr" element={<ReportingCTR />} />
            <Route path="/reporting/ftr" element={<ReportingFTR />} />
            <Route path="/reporting/board" element={<BoardReports />} />
            <Route path="/models" element={<Models />} />
            <Route path="/models/:mid" element={<ModelDetail />} />
            <Route path="/atom-explainer" element={<AtomExplainer />} />
            <Route path="/analytics" element={<BehaviouralAnalytics />} />
            <Route path="/governance/audit-log" element={<AuditLog />} />
            <Route path="/governance/access" element={<AccessControl />} />
            <Route path="/governance/examination-readiness" element={<ExaminationReadiness />} />
            <Route path="/governance/culture" element={<ComplianceCulture />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
